import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFiltersApi } from '../api/commonApi';
import { apiGetFilters } from '../helpers/api';
import { fetchAllPages } from '../helpers/apiHelper';
import { bulkUpdateFilters, selectFiltersFetchedOnce } from '../redux/slicers/filters/filterSlicer';
import { isMattressBuilderPage } from '../components/admin/curator/ProductBuilderComponents/commonHelper';
import { selectCuratorInitFinished } from '../redux/slicers/admin/curatorSlicer';

export const useFetchAllFilters = ({ skip }, deps) => {
  const dispatch = useDispatch();
  const curatorInitialized = useSelector(selectCuratorInitFinished);
  const filterFetchedRef = useRef(null);

  useEffect(() => {
    if (skip) return;
    // TODO: add pagination here
    if (isMattressBuilderPage()) {
      // In case of mattress builder, fetching filters after curator initialized
      if (curatorInitialized) dispatch(getFiltersApi());
    } else {
      if (!filterFetchedRef.current) {
        filterFetchedRef.current = true;
        dispatch(getFiltersApi());
      }
    }
  }, [skip, ...deps, curatorInitialized]);
};

export const useRefreshFilter = ({ type, id, skip }) => {
  const dispatch = useDispatch();
  const allFiltersFetched = useSelector(selectFiltersFetchedOnce);
  const curatorInitialized = useSelector(selectCuratorInitFinished);
  const filterFetchedRef = useRef(null);

  useEffect(() => {
    // when page loads we load all filters -> if all filters weren't loaded it means that they are still loading and we don't need to get latest version of filters as we will have latest version when all filters will load
    if (!allFiltersFetched) return;
    if (skip) return;
    const getFilters = async () => {
      // TODO: add pagination here and remove per page
      const result = await fetchAllPages((page) => {
        return apiGetFilters({ type, perPage: 20, page });
      });

      if (result?.results) {
        dispatch(bulkUpdateFilters(result.results));
      }
    };

    if (isMattressBuilderPage()) {
      // In case of mattress builder, fetching filters after curator initialized
      if (curatorInitialized) getFilters();
    } else {
      if (!filterFetchedRef.current) {
        filterFetchedRef.current = true;
        getFilters();
      }
    }
  }, [skip, curatorInitialized]);
};
